// extracted by mini-css-extract-plugin
module.exports = {"section":"diferenciais_section__CmJOU","image":"diferenciais_image__sN_5_","contentTab":"diferenciais_contentTab__OQmlO","icon":"diferenciais_icon__fEnVM"};